/**
 * UnitStatusBadge — a 8-state `EquipmentUnitStatus` badge (header + timeline).
 *
 * A `@kgc/ui` `StatusBadge` csak 4 equipment-statet ismer (AVAILABLE/RENTED/UNDER_REPAIR/RETIRED),
 * a kanonikus `EquipmentUnitStatus` viszont 8-state → saját FE-badge a teljes 8-state szín+label
 * map-pel (Botka measured-recon, seam #354). A szín/label map a `./unit-status` modulban.
 */
import type { EquipmentUnitStatus } from '@kgc/equipment-type-domain';
import { useTranslation } from '@kgc/i18n';

import { UNIT_STATUS_COLORS, unitStatusLabelKey } from './unit-status';

export function UnitStatusBadge({
  status,
  size = 'md',
}: {
  status: EquipmentUnitStatus;
  size?: 'sm' | 'md';
}) {
  const { t } = useTranslation();
  const sizeCls = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';
  return (
    <span
      data-testid={`unit-status-${status}`}
      className={`inline-flex items-center gap-1 rounded-md font-semibold ${sizeCls} ${UNIT_STATUS_COLORS[status]}`}
    >
      {t(unitStatusLabelKey(status))}
    </span>
  );
}
